// ARQUIVO: utils/transformers.js
// FUNÇÃO: Centralizar as funções de transformação de dados entre o app e o MongoDB

// Estas funções padronizam a conversão de dados entre o formato do app
// e o formato esperado pelo MongoDB, garantindo consistência.

// Transformar formulário para formato da API
export const transformFormToApi = (form) => {
  if (!form) return null;
  
  console.log('🔄 Transformando formulário para formato da API:', form.id);
  console.log('📋 Total de requirements:', form.requirements?.length || 0);
  
  // Verificar se temos requirements para transformar
  if (!form.requirements || form.requirements.length === 0) {
    console.warn('⚠️ Formulário sem requirements durante transformação para API!');
  }
  
  const transformedForm = {
    id: form.id,
    title: form.title,
    description: form.description,
    author: form.author || `${form.metadata?.avaliador1 || ''} & ${form.metadata?.avaliador2 || ''}`,
    createdAt: form.createdAt,
    updatedAt: form.updatedAt || form.createdAt,
    status: form.status || 'published',
    questions: transformRequirementsToQuestions(form.requirements || []),
    metadata: transformMetadata(form.metadata),
    version: form.version,
    estimatedTime: form.estimatedTime,
    isCustom: form.isCustom === undefined ? true : form.isCustom,
    totalQuestions: form.totalQuestions || (form.requirements ? form.requirements.length : 0),
    // Mantendo o campo requirements original para garantir
    requirements: form.requirements || []
  };
  
  // Log para verificar se as questões foram transformadas corretamente
  console.log('✅ Transformação concluída. Questões na API:', transformedForm.questions?.length || 0);
  
  return transformedForm;
};

// Transformar requisitos para formato de questões da API - CORRIGIDO
const transformRequirementsToQuestions = (requirements) => {
  // Verificar se temos dados para processar
  if (!requirements || requirements.length === 0) {
    console.warn('⚠️ Nenhum requisito para transformar em questões!');
    return [];
  }
  
  console.log(`🔄 Transformando ${requirements.length} requisitos em questões...`);
  
  try {
    const questions = requirements.map((req, index) => {
      // Verificar se os campos obrigatórios existem
      if (!req.codigo || !req.question) {
        console.warn('⚠️ Requisito sem código ou questão:', req);
      }
      
      // Garantir que sectionInfo esteja presente
      const sectionInfo = req.sectionInfo || {};
      
      // Criar objeto completo mantendo todos os campos do requisito original
      return {
        // Campos básicos para a API
        id: req.id || req.codigo,
        text: req.question,
        code: req.codigo,
        category: sectionInfo.tipo && sectionInfo.categoria 
          ? `${sectionInfo.tipo} - ${sectionInfo.categoria}` 
          : 'Categoria não especificada',
        status: req.status || 'pendente',
        notes: req.premissa || '',
        attachments: req.attachments || [],
        
        // Campos originais completos para preservar dados
        premissa: req.premissa || '',
        fontes: req.fontes || '',
        segmento: req.segmento || '',
        isEssential: req.isEssential || false,
        question: req.question, // Mantendo o campo original
        
        // Informações da seção completas
        sectionInfo: {
          tipo: sectionInfo.tipo || '',
          categoria: sectionInfo.categoria || '',
          subcategoria: sectionInfo.subcategoria || ''
        },
        
        // Ordem
        order: req.order || index + 1,
        
        // Manter qualquer outra propriedade que possa existir no requisito original
        ...req
      };
    });
    
    console.log(`✅ Transformação concluída. ${questions.length} questões transformadas.`);
    return questions;
  } catch (error) {
    console.error('❌ Erro ao transformar requisitos em questões:', error);
    return [];
  }
};


// Transformar metadados - CORRIGIDO
const transformMetadata = (metadata) => {
  if (!metadata) return {};
  
  return {
    ...metadata,
    // Garantir que as unidades organizacionais preservem todos os campos
    unidadesOrganizacionais: Array.isArray(metadata.unidadesOrganizacionais) 
      ? metadata.unidadesOrganizacionais.map(unidade => ({
          id: unidade.id,
          codigo: unidade.codigo,
          nome: unidade.nome,
          telefone: unidade.telefone || 'Não informado',
          email: unidade.email || 'Não informado',
          nivel: unidade.nivel || 0,
          parent: unidade.parent || null,
          searchText: unidade.searchText || `${unidade.codigo} ${unidade.nome}`,
          // Garantir que qualquer outra propriedade seja preservada
          ...unidade
         }))
      : [],
    // ADICIONAR: Garantir que emails das lideranças sejam preservados
    emailsLiderancas: Array.isArray(metadata.emailsLiderancas) 
      ? metadata.emailsLiderancas 
      : []
  };
};

// Transformar resposta para formato da API
// Função transformResponseToApi aprimorada para garantir que os dados do avaliador sejam enviados corretamente
// Função transformResponseToApi corrigida para garantir que os dados do avaliador sejam sempre incluídos
export const transformResponseToApi = (response) => {
  if (!response) return null;
  
  console.log('🔄 Transformando resposta para formato da API:', response.id);

  
  // LOG para debug de attachments
  if (response.attachments && Object.keys(response.attachments).length > 0) {
    console.log('📎 Anexos na resposta:', Object.keys(response.attachments).map(questionId => ({
      questionId,
      count: response.attachments[questionId].length,
      urls: response.attachments[questionId].map(a => ({
        name: a.name,
        url: a.url,
        uri: a.uri,
        hasUrl: !!a.url,
        hasUri: !!a.uri
      }))
    })));
  }
  
  // Valores padrão para avaliador (muito importante!)
  const DEFAULT_AVALIADOR = {
    id: 'av00',
    nome: 'sem_nome',
    login: 'sem_email@ebserh.gov.br',
    level: 'membro'
  };
  
  // CORREÇÃO CRÍTICA: Garantir que o avaliador esteja sempre presente e completo
  // Mesmo antes de qualquer verificação, definir um avaliador padrão
  let avaliador = DEFAULT_AVALIADOR;
  
  // Se houver dados do avaliador na resposta, verificar se estão completos
  if (response.avaliador) {
    // Verificar se todos os campos necessários estão presentes
    const camposNecessarios = ['id', 'nome', 'login', 'level'];
    const temTodosCampos = camposNecessarios.every(campo => Boolean(response.avaliador[campo]));
    
    if (temTodosCampos) {
      // Se todos os campos estão presentes, usar o avaliador da resposta
      avaliador = response.avaliador;
    } else {
      // Se faltam campos, mesclar com os valores padrão
      avaliador = {
        ...DEFAULT_AVALIADOR,  // Valores padrão como base
        ...response.avaliador, // Sobrescrever com os valores fornecidos que existem
      };
      
      console.log('⚠️ Dados do avaliador incompletos, mesclando com padrão:', avaliador);
    }
  } else {
    console.log('⚠️ Avaliador não encontrado na resposta, usando padrão:', DEFAULT_AVALIADOR);
  }
  
  console.log('👤 Dados do avaliador para envio:', avaliador);
  
 // Construir o objeto de resposta para a API com o avaliador garantido
  const transformedResponse = {
    id: response.id,
    formId: response.formId,
    formTitle: response.formTitle,
    createdAt: response.createdAt,
    completedAt: response.completedAt,
    syncedAt: response.syncedAt,
    lastModified: response.lastModified || new Date().toISOString(),
    isComplete: response.isComplete === undefined ? false : response.isComplete,
    synced: response.synced === undefined ? false : response.synced,
    answers: response.answers || {},
    findings: response.findings || {},
    savedFindings: response.savedFindings || {},
    notApplicableReasons: response.notApplicableReasons || {},
    attachments: transformAttachments(response.attachments || {}),
    // CORREÇÃO CRÍTICA: Garantir que os dados do avaliador sejam enviados completos
    avaliador: avaliador,
    // IMPORTANTE: Preservar campo de validação
    validacao: response.validacao || null,
    totalQuestions: response.totalQuestions || 0
  };
  
  // Log para confirmar que avaliador está sendo incluído
  console.log('✅ Resposta transformada. Avaliador incluído:', 
    transformedResponse.avaliador ? 
    `${transformedResponse.avaliador.nome} (${transformedResponse.avaliador.id})` : 
    'ERRO: Avaliador ausente');
  
  return transformedResponse;
};


// Transformar anexos (sem mudanças)
const transformAttachments = (attachments) => {
  const transformedAttachments = {};
  
  Object.keys(attachments).forEach(questionId => {
    transformedAttachments[questionId] = (attachments[questionId] || []).map(attachment => {
      // CRÍTICO: Preservar todos os dados do anexo
      return {
        id: attachment.id,
        type: attachment.type,
        url: attachment.url || attachment.uri,
        uri: attachment.uri || attachment.url,
        base64: attachment.base64, // IMPORTANTE: Preservar base64
        name: attachment.name || 'Anexo sem nome',
        size: attachment.size,
        mimeType: attachment.mimeType,
        description: attachment.description || '',
        validityDate: attachment.validityDate,
        createdAt: attachment.createdAt || new Date().toISOString(),
        supabasePath: attachment.supabasePath,
        supabaseUrl: attachment.supabaseUrl,
        supabaseBucket: attachment.supabaseBucket,
        localOnly: attachment.localOnly !== undefined ? attachment.localOnly : true,
        synced: attachment.synced || false,
        syncedAt: attachment.syncedAt,
        hasLocalData: attachment.hasLocalData || !!attachment.base64,
        questionId: attachment.questionId || questionId,
      };
    });
  });
  
  return transformedAttachments;
};
// Transformar dados da API para formato do app (formulário) - CORRIGIDO E MELHORADO
// 2. Enhanced transformApiToForm function for transformers.js
export const transformApiToForm = (apiData) => {
  if (!apiData) return null;
  
  console.log(`🔄 Transformando dados da API para formato do app (form ID: ${apiData.id})`);
  
  // Verificar se temos questions ou requirements
  const hasQuestions = apiData.questions && apiData.questions.length > 0;
  const hasRequirements = apiData.requirements && apiData.requirements.length > 0;
  
  console.log(`📊 Dados da API: ${hasQuestions ? apiData.questions.length : 0} questões, ${hasRequirements ? apiData.requirements.length : 0} requisitos`);
  
  // CORREÇÃO: Preservar requirements originais se disponíveis, ou transformar questions em requirements
  let requirements = [];
  
  if (hasRequirements) {
    // Se tem requirements, usar diretamente
    console.log('✅ Usando requirements originais da API');
    requirements = apiData.requirements;
  } else if (hasQuestions) {
    // Se não tem requirements mas tem questions, transformar
    console.log('🔄 Transformando questions em requirements');
    requirements = transformApiQuestionsToRequirements(apiData.questions);
  } else {
    console.warn('⚠️ API não retornou nem questions nem requirements');
    requirements = [];
  }
  
  // Log para verificar
  console.log(`📋 Total de requirements após transformação: ${requirements.length}`);
  // CORREÇÃO: Ordenar requirements pelo campo order
  if (requirements.length > 0) {
    requirements.sort((a, b) => {
      const orderA = a.order || 999999;
      const orderB = b.order || 999999;
      return orderA - orderB;
    });
    console.log('✅ Requirements ordenados pelo campo order');
  }
  // Garantir que temos um ID válido

  
  const formId = apiData.id || `custom-form-${Date.now()}-${Math.random().toString(36).substring(2, 7)}`;
  
  
  // Construir o objeto de formulário completo
  return {
    id: formId,
    title: apiData.title || 'Formulário sem título',
    description: apiData.description || '',
    version: apiData.version || '1.0',
    totalQuestions: apiData.totalQuestions || requirements.length,
    estimatedTime: apiData.estimatedTime || requirements.length * 3,
    isCustom: apiData.isCustom !== undefined ? apiData.isCustom : true,
    createdAt: apiData.createdAt || new Date().toISOString(),
    updatedAt: apiData.updatedAt || apiData.createdAt || new Date().toISOString(),
    status: apiData.status || 'published',
    author: apiData.author || '',
    synced: true,
    syncedAt: apiData.updatedAt || apiData.syncedAt || new Date().toISOString(),
    metadata: transformApiMetadata(apiData.metadata || {}),
    requirements: requirements
  };
};



// 3. Enhanced transformApiQuestionsToRequirements function for transformers.js
const transformApiQuestionsToRequirements = (questions) => {
  if (!questions || questions.length === 0) {
    console.warn('⚠️ Nenhuma questão para transformar em requisitos!');
    return [];
  }
  
  console.log(`🔄 Transformando ${questions.length} questões em requisitos...`);
  
  try {
    const requirements = questions.map((question, index) => {
      // Verificar campos obrigatórios
      if (!question.code && !question.id) {
        console.warn('⚠️ Questão sem código ou ID:', question);
      }
      
      // Extrair informações da seção ou usar existente
      const sectionInfo = question.sectionInfo || extractSectionInfo(question.category) || {
        tipo: 'Não categorizado',
        categoria: 'Geral',
        subcategoria: ''
      };
      
      // Construir objeto de requisito completo
      return {
        id: question.id || question.code || `req-${index}`,
        codigo: question.code || question.codigo || `${index + 1}`,
        question: question.text || question.question || 'Sem texto',
        premissa: question.premissa || question.notes || '',
        fontes: question.fontes || '',
        segmento: question.segmento || '',
        isEssential: question.isEssential || false,
        sectionInfo: sectionInfo,
        order: question.order || index + 1,
        
        // IMPORTANTE: Preservar todos os campos originais
        ...question
      };
    });
    
    console.log(`✅ Transformação concluída. ${requirements.length} requisitos transformados.`);
    
    // CORREÇÃO: Ordenar pelo campo order antes de retornar
    requirements.sort((a, b) => {
      const orderA = a.order || 999999;
      const orderB = b.order || 999999;
      return orderA - orderB;
    });
    
    return requirements;
  } catch (error) {
    console.error('❌ Erro ao transformar questões em requisitos:', error);
    // Retornar array vazio em vez de falhar completamente
    return [];
  }
};
// Extrair informações de seção a partir da categoria - CORRIGIDO
const extractSectionInfo = (category) => {
  if (!category) return { tipo: '', categoria: '', subcategoria: '' };
  
  try {
    const parts = category.split(' - ');
    return {
      tipo: parts[0] || '',
      categoria: parts[1] || '',
      subcategoria: parts[2] || ''
    };
  } catch (error) {
    console.error('❌ Erro ao extrair informações de seção:', error);
    return { tipo: '', categoria: '', subcategoria: '' };
  }
};

// Transformar metadados da API
const transformApiMetadata = (metadata) => {
  if (!metadata) return {};
  
  return {
    ...metadata,
    unidadesOrganizacionais: Array.isArray(metadata.unidadesOrganizacionais) 
      ? metadata.unidadesOrganizacionais
      : []
  };
};

// Transformar dados da API para formato do app (resposta)
// Função transformApiToResponse aprimorada para preservar os dados do avaliador
// Função transformApiToResponse aprimorada para preservar os dados do avaliador
export const transformApiToResponse = (apiData) => {
  if (!apiData) return null;
  
  console.log(`🔄 Transformando resposta API para app: ${apiData.id}`);
  
  // Valores padrão para avaliador
  const DEFAULT_AVALIADOR = {
    id: 'av00',
    nome: 'sem_nome',
    login: 'sem_email@ebserh.gov.br',
    level: 'membro'
  };
  
  // Garantir que os dados do avaliador sejam preservados corretamente
  let avaliador = DEFAULT_AVALIADOR;
  
  // Se os dados da API contiverem informações do avaliador, usá-los
  if (apiData.avaliador) {
    // Verificar se todos os campos necessários estão presentes
    const camposNecessarios = ['id', 'nome', 'login', 'level'];
    const temTodosCampos = camposNecessarios.every(campo => Boolean(apiData.avaliador[campo]));
    
    if (temTodosCampos) {
      // Se todos os campos estão presentes, usar o avaliador da API
      avaliador = apiData.avaliador;
    } else {
      // Se faltam campos, mesclar com os valores padrão
      avaliador = {
        ...DEFAULT_AVALIADOR,  // Valores padrão como base
        ...apiData.avaliador,  // Sobrescrever com os valores fornecidos que existem
      };
      
      console.log('⚠️ Dados do avaliador incompletos na API, mesclando com padrão:', avaliador);
    }
  } else {
    console.warn('⚠️ API retornou resposta sem avaliador. Usando avaliador padrão.');
  }
  
  // Log para confirmar
  console.log('👤 Avaliador após transformação API→App:', 
    avaliador ? `${avaliador.nome} (${avaliador.id})` : 'ERRO: Avaliador ausente');
  
  // Construir o objeto de resposta para o app
  // Construir o objeto de resposta para o app
  const transformedResponse = {
    id: apiData.id,
    formId: apiData.formId,
    formTitle: apiData.formTitle,
    createdAt: apiData.createdAt,
    completedAt: apiData.completedAt,
    syncedAt: apiData.syncedAt,
    lastModified: apiData.lastModified,
    isComplete: apiData.isComplete,
    synced: apiData.synced,
    answers: apiData.answers || {},
    findings: apiData.findings || {},
    savedFindings: apiData.savedFindings || {},
    notApplicableReasons: apiData.notApplicableReasons || {},
    attachments: apiData.attachments || {},
    // CORREÇÃO: Garantir que os dados do avaliador estejam completos
    avaliador: avaliador,
    // IMPORTANTE: Preservar campo de validação
    validacao: apiData.validacao || null,
    totalQuestions: apiData.totalQuestions || 0
  };
  
  return transformedResponse;
};